var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1358_65762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.77231 6.36456C2.59718 7.00671 2.52129 7.68584 2.57318 8.38704",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.74072 4.42003C4.02094 4.03798 4.34591 3.6916 4.7085 3.38544",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12254 12.9067C4.21832 12.282 3.49508 11.4109 3.04297 10.3854",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2973 8.76095C9.76273 9.24869 9.09593 9.68849 8.361 9.98689C7.7364 10.2353 7.21227 9.92529 7.13573 9.30382C7.04233 8.38729 7.04427 7.50969 7.13573 6.69109C7.2194 6.04505 7.79607 5.77067 8.361 6.01003C9.08427 6.30905 9.73293 6.71509 10.2973 7.23662C10.7792 7.67702 10.7909 8.30302 10.2973 8.76095Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2629 12.7239C11.3587 13.4323 10.2424 13.8909 9.01056 13.983C8.40409 14.0284 7.81189 13.9804 7.24756 13.8533",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6522 11.1492C14.2587 10.1703 14.5966 9.01254 14.5493 7.77554C14.4215 4.46032 11.6317 1.87676 8.31641 2.00454",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1358_65762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.044b7ff4f85dc16c3ad9abdcd71a6627.svg";
export { ForwardRef as ReactComponent };